//@flow
import React from 'react';
import styled from 'styled-components';
import QuestionIcon from '../icons/Question';
import Section from './Section';

export default ({ header, body }: { header: string, body: string }) => {
  return (
    <Section skewed={false} noBackground={true}>
      <Header>
        <QuestionIcon />
        <H1>{header}</H1>
      </Header>
      <Body>{body}</Body>
    </Section>
  );
};

const Header = styled.div`
  && {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const H1 = styled.h1`
  && {
    margin-top: 20px;
  }
`;

const Body = styled.p`
  && {
    max-width: 400px;
    margin: auto;
  }
`;
